import systemApi from '@api/system'
import mainStore from '@components/Main/store'
import {
  PROPERTY_HOTEL,
  PROPERTY_RING,
  PROPERTY_WEDDING_DRESS_ID,
  PROPERTY_WEDDING_PHOTO_ID,
  PROPERTY_WEDDING_PLAN_ID
} from '@constant'
import { isEmptyObj } from '@hlj/hlj-utils'
import { getSessionMerchantInfo, isOnlineShop } from '@merchant-backend/util'
import { toJS } from 'mobx'
import {
  isHotelProperty,
  isWeddingRingJewelryProperty,
  isFlowerDessert
} from '@merchant-backend/util'
/**
 * 获取商家信息
 */
export const getMerchantInfo = () => {
  const info = isEmptyObj(toJS(mainStore.merchantInfo))
    ? getSessionMerchantInfo()
    : mainStore.merchantInfo

  return info
}

/**
 * 全局获取 ShopInfo
 * 获取一次后存入 sessionStorage
 */
export const getShopInfo = async () => {
  const shop_info = sessionStorage.getItem('shop_info')
  if (shop_info) {
    return JSON.parse(shop_info)
  }

  const { success, data } = await systemApi.shopInfo()

  if (success) {
    sessionStorage.setItem('shop_info', JSON.stringify(data))
    return data
  }

  return {}
}

/**
 * 是否是电销城市商家
 */
export const isTelSaleCityMerchant = () => {
  return getMerchantInfo().is_sale_city == 1
}

/**
 * 开通线上店铺新商家，包含
 * 婚纱摄影、婚礼策划、婚纱礼服、婚宴酒店、婚戒首饰五个类目
 */
export const isNewMerchantOnlineShop = () => {
  const { property_id } = getMerchantInfo()
  const pIds = [
    PROPERTY_WEDDING_PHOTO_ID,
    PROPERTY_WEDDING_PLAN_ID,
    PROPERTY_WEDDING_DRESS_ID,
    PROPERTY_HOTEL,
    PROPERTY_RING
  ]
  return pIds.some(id => id == property_id) && isOnlineShop()
}

/**
 * 使用新版营销页的商家
 * 婚纱摄影、婚礼策划、婚纱礼服、婚宴酒店、婚戒首饰五个类目
 */
export const isNewShopProductMerchant = () => {
  const { property_id } = getMerchantInfo()
  const pIds = [
    PROPERTY_WEDDING_PHOTO_ID,
    PROPERTY_WEDDING_PLAN_ID,
    PROPERTY_WEDDING_DRESS_ID,
    PROPERTY_HOTEL,
    PROPERTY_RING
  ]
  return pIds.some(id => id == property_id)
}

// 盘古商家不迁移类目
export const panguStoreType = () => {
  const { property_id } = getMerchantInfo()
  return isFlowerDessert(property_id)
}

/* 是否开店阶段 */
export const isNewOpen = () => {
  const { hidden } = getMerchantInfo()
  return hidden == 5
}
